import React from 'react'
import { SalesPersonApi } from '../../../api/salespeopleApi'
import MUIDataTable from "mui-datatables";
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import Notification from '../../Notifications'
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import DateFnsUtils from '@date-io/date-fns';
import 'date-fns';
import esLocale from "date-fns/locale/es";

import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    DatePicker,
  } from '@material-ui/pickers';

  
const toInputUppercase = e => {
    e.target.value = ("" + e.target.value).toUpperCase();
};

const options = {
    selectedRows: {
        text: "fila(s) seleccionada",
        delete: "Delete",
        deleteAria: "Desactivar vendedor"
    },
    downloadOptions: {
        filename: 'Listado vendedores.csv',
        separator: ','
    },
    textLabels: {
        body: {
            noMatch: "No hay vendedores registrados",
            toolTip: "Sort",
        },
        pagination: {
            next: "Siguiente pag",
            previous: "Anterior",
            rowsPerPage: "Filas por pagina:",
            displayRows: "de",
        },
        toolbar: {
            search: "Buscar",
            downloadCsv: "Descargar CSV",
            print: "Imprimir",
            viewColumns: "Ver columnas",
            filterTable: "Filtrar tabla",
        },
        selectedRows: {
            text: "fila(s) seleccionadas",
            delete: "Desactivar",
            deleteAria: "Desactivar vendedor(es)",
        },

    },

}

import { createMuiTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import lightBlue from "@material-ui/core/colors/lightBlue";
import {muitheme} from '../../../theme/muiTheme'

const materialTheme = createMuiTheme({
    palette: {
        primary: {
          main: '#ea8b0e',
        },
        secondary: {
          main: '#cea671',
        },
        title: {
          color: 'white',
        },
        background: {
          main: "#cbd0d8"
        }
      },
    typography: {
        fontFamily: "Helvetica",
        fontSize: 20,
        fontWeightLight: 300,
        fontWeightRegula: 400,
        fontWeightMedium: 500,
        h4: {
          fontFamily: "\"Rock Salt\"",
          color: "#393c42",
          fontSize: 20,
        }
      },
   
  });


export class SalesPeopleView extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            columns: [
                { name: "Id", options: {filter: false, download: false, display: false, viewColumns: false, print: false}},
                {   
                    name: "Status", options: {
                        filterType: 'dropdown',
                        filterList: ['Activo'],
                    }
                },
                { name: "Nombre" },
                { name: "Fecha Ingreso", options: { filter: false } },
                { name: "Email", options: { filter: false } },
                { name: "Telefono", options: { filter: false } },
                { name: "Direccion", options: { filter: false } },
                { name: "Fecha de Nacimiento", options: { filter: false } },
                ],

            title: "Nomina de vendedores",
            salesPeopleCatalog: [],
            isLoading: true,
            showMsg: false,
            msgType: 'error', // success/error/warning
            msg: null,
            salesmanName: null,
            salesmanEmail: null,
            salesmanAddress: null,
            salesmanBirthDate: new Date('1995-01-01T21:11:54'),
            salesmanPhone: null,
        },
        options['onRowsDelete'] = this.deactivateSalesPerson

    }
    deactivateSalesPerson = (rowsDeleted) => {
        const deleteSalesResources = rowsDeleted.data.map((data) => {
            return this.state.salesPeopleCatalog[data.dataIndex][0]
        });
        const data = {'active': false, 'id': deleteSalesResources[0]}

        SalesPersonApi.updateSalesResources(data)
        .then( response =>{
            this.setState({showMsg: true, msgType: 'success', msg:'Vendor(es) desactivados'})
            this.updateSalesPeople()
        })
        .catch(error =>{
            console.log(error)
            this.setState({showMsg: true, msgType: 'error', msg:'No se pudo realizar la operacion'})
            
        })
    }

    updateSalesPeople = () => {
        SalesPersonApi.getSalesPayroll().then(list => {
            let rows = []   
            list.data.map(function (salesperson) {
                const active = salesperson.active ? 'Activo' : 'Inactivo';
                let date = new Date(salesperson.created_on)
                date = date.toLocaleDateString()
                let birthDate = null
                if(salesperson.birth_date != null){
                        birthDate = salesperson.birth_date.split(' ')[0].split('-')
                        birthDate = birthDate[0] + '/' + birthDate[2] + '/' + birthDate[1]
                }

                rows.push([salesperson.id, active, salesperson.username, date,
                   
                    salesperson.email, salesperson.phone, salesperson.address, birthDate])
            })
            this.setState({ salesPeopleCatalog: rows, isLoading: false })
        })
    }
    componentDidMount = () => {
        this.updateSalesPeople()

    }
   
    createSalesman = () => {
        const date = new Date(this.state.salesmanBirthDate);
        var dateString = new Date(date.getTime() - (date.getTimezoneOffset() * 60000 ))
                    .toISOString()
                    .split("T")[0];
  
        const salespersonData = {'username': this.state.salesmanName, 'email':this.state.salesmanEmail,
        'phone': this.state.salesmanPhone, 'address': this.state.salesmanAddress,
        'location': 'Bahia Blanca', 'birth_date': dateString,
       }

        SalesPersonApi.createSalesPerson(salespersonData)
       
        .then(response =>{
            this.setState({ msg: 'Vendedor creado', msgType: 'success', showMsg: true })
            this.updateSalesPeople()

        })
        .catch(error=>{
            let msg = 'Intente nuevamente'
            if(error.response.status == 406){
                msg = 'El vendedor ya existe'
            }
            this.setState({showMsg: true, msg: msg, msgType: "error"})

        })
    }

    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ showMsg: false });
    }
    handleDateChange = (date) => {
        this.setState({ salesmanBirthDate: date })
    };

    
    isDisabled = () => {
        let enabled = true;
        if (this.state.salesmanEmail == null || this.state.salesmanEmail == '') {
            enabled = false;
        }
       

        if (this.state.salesmanPhone == null || this.state.salesmanPhone == '') {
            enabled = false;
        }

        if (this.state.salesmanName == null || this.state.salesmanName == '') {
            enabled = false;
        }
        if (this.state.salesmanAddress == null || this.state.salesmanAddress == '') {
            enabled = false;
        }
        return !enabled;
    }

    setDate = (date) => {
       this.setState({salesmanBirthDate: date})
    }

    loadCatalog = () => {
        return (<div>
            <MUIDataTable
                title={this.state.title}
                data={this.state.salesPeopleCatalog}
                columns={this.state.columns}
                options={options}
            />

            <Divider />
            <Typography variant="subtitle1" gutterBottom>
                Alta Vendedor
                        </Typography>
            <div className='col-md-3'>
                <TextField
                    label={"Nombre y apellido"}
                    value={this.state.salesmanName}
                    onInput={toInputUppercase}
                    onChange={e => {
                        let value = e.target.value;
                        value = value.replace(/[^A-Za-z\s]/gi, "");
    
                        this.setState({
                            salesmanName: value
                        });
                    }}
                    id="salesmanName"

                />
            </div>
            <div className='col-md-3'>
                <TextField
                    label={"Direccion"}
                    onInput={toInputUppercase}
                    value={this.state.salesmanAddress}
                    onChange={e => {
                        this.setState({
                            salesmanAddress:  e.target.value
                        });
                    }}
                    id="salesmanAddress"

                />
            </div>
           
            <div className='col-md-2'>
                <TextField
                    label={"telefono"}
                    value={this.state.salesmanPhone}
                    onChange={e => {
                        let value = e.target.value;
    
                        value = value.replace(/[^0-9]/gi, "");
    
                        this.setState({
                            salesmanPhone: value
                        });
                    }}
                    id="salesmanPhone"

                />
            </div>
            <div className='col-md-2'>
                <TextField
                    label={"Email"}
                    onInput={toInputUppercase}
                    type='email'
                    value={this.state.salesmanEmail}
                    onChange={e => {
                        this.setState({
                            salesmanEmail:  e.target.value
                        });
                    }}
                    id="salesmanEmail"

                />
            </div>
            <div className='col-md-3'>
            <ThemeProvider theme={muitheme}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                <DatePicker
                    inputVariant="standard"
                    variant="dialog"
                    format="dd/MM/yyyy"
                    id="salesmanBirthDate"
                    label="Fecha de Nacimiento"
                    value={this.state.salesmanBirthDate}
                    onChange={(e) =>this.setState({salesmanBirthDate: e})}
                  
                />
            </MuiPickersUtilsProvider>
            </ThemeProvider>
            </div>

            <div className="col-md-1 col-md-offset-10">
                <Button
                    onClick={this.createSalesman}
                    variant="contained"
                    color="primary"
                    disabled={this.isDisabled()}
                >
                    Alta Vendedor
                    </Button>
            </div>
            <Notification
                open={this.state.showMsg}
                variant={this.state.msgType}
                message={this.state.msg}
                onClose={this.handleClose}
            />

        </div>)
    }

    render() {
        return (
            <div>
                {this.state.isLoading
                    ? <div style={{ marginTop: 70 }} className="col-md-6 col-md-offset-5">
                        <CircularProgress
                            size={80}
                            color='primary'
                            thickness={3}
                            style={{ display: 'center' }} />
                    </div>
                    : <div>{this.loadCatalog()}</div>
                }
            </div>
        )

    }
}


// WEBPACK FOOTER //
// ./src/components/Admin/Hhrr/SalesPeople.js